import { FETCH_ALL_COURSES_FOR_VOLUNTEER } from '../../constants/actionTypes'

export default (vlnVolunteerCourses = [], action) => {
    switch (action.type) {
        case FETCH_ALL_COURSES_FOR_VOLUNTEER:
            return action.payload;
        default:
            return vlnVolunteerCourses;
    }
}